import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import PropTypes from 'prop-types';
import './Graph.scss';

const Graph = ({ graphKey, constructorType, graphOptions, children }) => (
    <div className="graph-container">
        {children}
        <HighchartsReact
            key={graphKey}
            highcharts={Highcharts}
            options={graphOptions}
            constructorType={constructorType}
        />
    </div>
);

Graph.defaultProps = {
    graphKey: null,
    constructorType: 'chart',
    graphOptions: {},
    children: null,
};

Graph.propTypes = {
    graphKey: PropTypes.string,
    constructorType: PropTypes.string,
    graphOptions: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Graph;
